"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Modal } from "@/components/ui/modal"
import { Sparkles } from "lucide-react"

export function AnnouncementModal({ isReady = true }: { isReady?: boolean }) {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (!isReady) return;

        // Check if the user has already seen and closed the modal
        const hasSeenModal = localStorage.getItem("has-seen-video-modal-v1")
        
        if (!hasSeenModal) {
            // Show modal after a short delay
            const timer = setTimeout(() => {
                setIsOpen(true)
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [isReady])

    const handleClose = () => {
        setIsOpen(false)
        // Persist the state so it doesn't show again
        localStorage.setItem("has-seen-video-modal-v1", "true")
    }

    return (
        <Modal 
            isOpen={isOpen} 
            onClose={handleClose} 
            className="max-w-3xl overflow-hidden rounded-3xl"
            zIndex={1000}
        >
            <div className="relative overflow-hidden bg-white">
                {/* Header Section */}
                <div className="px-5 py-3 flex items-center justify-between border-b border-gray-100">
                    <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                            <Sparkles className="w-4 h-4 text-blue-600" />
                        </div>
                        <div>
                            <h2 className="text-base font-bold font-syne text-gray-900 leading-tight">
                                Elevate Your Fundraising Pitch
                            </h2>


                        </div> 
                    </div>
                </div>


                {/* Video Player Section */}
                <div className="relative aspect-video w-full bg-black overflow-hidden">
                    <iframe
                        src="https://www.youtube.com/embed/GcpG2FxGFCI?autoplay=1&mute=1"
                        title="Deckwale AI Introduction"

                        className="absolute inset-0 w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </Modal>
    )
}
